import { metrics } from '@atlassian/browser-metrics';
import {
	PERF_METRICS_TABS_PREFIX,
	WORKEDON_TAB_KEY,
	VIEWED_TAB_KEY,
	ASSIGNED_TAB_KEY,
	STARRED_TAB_KEY,
	BOARDS_TAB_KEY,
	WORK_SUGGESTIONS_TAB_KEY,
} from '../../constants/tab-content.tsx';

export const interactionMetrics = {
	[ASSIGNED_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${ASSIGNED_TAB_KEY}`,
	}),
	[WORKEDON_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${WORKEDON_TAB_KEY}`,
	}),
	[VIEWED_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${VIEWED_TAB_KEY}`,
	}),
	[STARRED_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${STARRED_TAB_KEY}`,
	}),
	[BOARDS_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${BOARDS_TAB_KEY}`,
	}),
	[WORK_SUGGESTIONS_TAB_KEY]: metrics.interaction({
		key: `${PERF_METRICS_TABS_PREFIX}.${WORK_SUGGESTIONS_TAB_KEY}`,
	}),
} as const;
